import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class CreateWorkerGuard implements CanActivate {

  constructor(private router: Router, private userService:UserService) { }

  canActivate(): boolean {
    const roleId = Number(localStorage.getItem('globalStoreRoleId'));

    console.log('Active role from OTP:', roleId);

    const blockedRoles = [1,3,4];   // ❌ No Trade worker create page access

    if (blockedRoles.includes(roleId)) {
      this.router.navigate(['/dashboard']);   // or any safe page
      return false;
    }
    return true;
  }
}
